import React from 'react'
import {ToastContainer } from 'react-toastify';
import Spinner from '../Spinner/spinner';
import UseAddCountry from './Hooks/useAddCountry';


const AddCountry = () => {
    const {spinner,countryAdd}=UseAddCountry()
    return (
        <>
            <ToastContainer />
            <section>
                <div className="cus-padd cusheight">
                    {spinner ? <Spinner /> : null}
                    <header>
                        <h2 className='page-tittle'>
                            Add Country
                        </h2>
                        <hr />
                    </header>
                    <form className="row g-3 mt-4" onSubmit={countryAdd.handleSubmit}>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Country Code *</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='code'
                                onChange={countryAdd.handleChange}
                                value={countryAdd.values.code}
                            />
                            {countryAdd.touched.code && countryAdd.errors.code ? (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                    {countryAdd.errors.code}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Country Name *</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='name'
                                onChange={countryAdd.handleChange}
                                value={countryAdd.values.name}
                            />
                            {countryAdd.touched.name && countryAdd.errors.name ? (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                    {countryAdd.errors.name}
                                </div>
                            ) : null}
                        </div>
                        <p>* Note : Please fill all the mandatory fields</p>
                        < div>
                            <button type="submit" className="btn btn-primary col-0">Submit</button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    )
}

export default AddCountry